module.exports = __webpack_public_path__ + "static/senior-people-c1a30c057a533b2abf3e38236cbce374.jpg";